import React, { useState } from "react";
import { Box, CardActionArea, Dialog, Grid } from "@mui/material";
import { grey } from "@mui/material/colors";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DottedTile from "../common/DottedTile";
import CognitoAiFileUpload from "./CognitoAiFileUpload";
import { useQueryClient } from "react-query";

const CognitoAiUploadTile = () => {
  const queryClient = useQueryClient();
  const [openModal, setOpenModal] = useState(false);
  const handleOpen = () => setOpenModal(true);
  const handleClose = () => setOpenModal(false);

  const handleUploadSuccess = () => {
    // Invalidate and refetch the cognito-ai uploads query
    queryClient.invalidateQueries("cognitoAiUploads");
  };

  return (
    <Grid item xs={12} sm={6} md={2} sx={{ display: "flex" }}>
      <CardActionArea
        onClick={handleOpen}
        sx={{ width: "100%", height: "100%", display: "flex" }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            "& .dotted-text": {
              margin: 0,
              lineHeight: 1.2,
            },
            "& .dotted-icon": {
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: 0.75,
            },
            "& > div": {
              width: "100%",
              minHeight: 180,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            },
          }}
        >
          <DottedTile title={"UPLOAD A NEW FILE"}>
            <CloudUploadIcon sx={{ fontSize: "3.5rem", color: grey[500] }} />
          </DottedTile>
        </Box>
      </CardActionArea>
      <Dialog
        open={openModal}
        maxWidth="md"
        fullWidth
        scroll="paper"
        PaperProps={{
          style: {
            maxHeight: "90%",
          },
        }}
      >
        {openModal && (
          <CognitoAiFileUpload
            handleClose={handleClose}
            open={openModal}
            onUploadSuccess={handleUploadSuccess}
          />
        )}
      </Dialog>
    </Grid>
  );
};

export default CognitoAiUploadTile;
